import React from 'react';
import PropTypes from 'prop-types';
import { getLeaseDealScore } from 'client/site-modules/lease-deals/utils/score';
import { ExplanatoryText } from 'site-modules/lease-deals/components/key-insights-list/explanatory-text';
import { GEM_DEAL_THRESHOLD } from 'site-modules/shared/constants/lease-deals/lease-deals';

const percentFormatter = new Intl.NumberFormat('en-US', { style: 'percent', maximumFractionDigits: 1 });

export function LeaseScoreInsight(props) {
  const { lifetimeCost, msrp, term, effectivePaymentRatio } = props;

  const isGemDeal = effectivePaymentRatio >= GEM_DEAL_THRESHOLD;
  const msrpPercentPaid = percentFormatter.format(lifetimeCost / msrp);
  const msrpEndingText = isGemDeal
    ? 'anything under 11% is exceptionally strong.'
    : 'anything over 15% offers poor value for the price.';

  return (
    <ExplanatoryText
      summary={
        <span>
          This lease costs{' '}
          <strong>{percentFormatter.format(getLeaseDealScore({ lifetimeCost, msrp, term }) / 100)}</strong> of{' '}
        </span>
      }
      toggleSummary="MSRP per year"
      details={`At the end of the lease, you will have paid ${msrpPercentPaid} of the MSRP value. Most competitive lease offers fall between 11-13% of MSRP per year, and ${msrpEndingText}`}
    />
  );
}

LeaseScoreInsight.propTypes = {
  lifetimeCost: PropTypes.number.isRequired,
  msrp: PropTypes.number.isRequired,
  term: PropTypes.number.isRequired,
  effectivePaymentRatio: PropTypes.number.isRequired,
};
